import { render, staticRenderFns } from "./SubscriptionsTypeDetail.vue?vue&type=template&id=623a4500&"
import script from "./SubscriptionsTypeDetail.vue?vue&type=script&lang=js&"
export * from "./SubscriptionsTypeDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports